package com.xtream.data_kmp.db.repo

import com.xtream.data_kmp.db.AppRoomDB
import com.xtream.data_kmp.dto.BaseStream
import com.xtream.data_kmp.dto.CategoryBase
import com.xtream.data_kmp.dto.CategoryWithStream
import com.xtream.data_kmp.dto.LiveCategory


class HomeStreamsRepository (
    private val db: AppRoomDB
){


    private suspend fun buildRow(id: Int): List<CategoryWithStream<BaseStream, CategoryBase>> {
        val streams: List<BaseStream> = when (id) {
            1 -> db.liveStreamsDao().getWatchedStreams(20)
            2 -> db.liveStreamsDao().getRecentlyAddedList(20)
            3 -> db.vodDao().getRecentlyAddedList(20)
            4 -> db.seriesDao().getRecentlyAddedList(20)
            else -> emptyList()
        }
        if (streams.isEmpty()) return emptyList()

        return listOf(
            CategoryWithStream(
                size = -1,
                streams = streams,
                category = when (id) {
                    1 -> LiveCategory(1, "Recently Watched TV", null)
                    2 -> LiveCategory(2, "Recently Added TVs", null)
                    3 -> LiveCategory(3, "Recently Added Movies", null)
                    4 -> LiveCategory(4, "Recently Added Series", null)
                    else -> LiveCategory(-1, "", null)
                }
            )
        )
    }
}

